import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=77c14ff6&scoped=true&"
import script from "./badge.js?vue&type=script&lang=js&"
export * from "./badge.js?vue&type=script&lang=js&"
import style0 from "./badge.scss?vue&type=style&index=0&id=77c14ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c14ff6",
  null
  
)

export default component.exports